import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/sgrishchenko/reselect-utils/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { TypedocFrame } from './TypedocFrame';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <TypedocFrame title="Cached Structured Selector" route="modules/_createcachedstructuredselector_" mdxType="TypedocFrame" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      